// Tooltip

'use strict';

icing.watch('[data-bs-toggle*="tooltip"]', e => new Tooltip(e));
